import { useEffect } from "react";
import { TextField, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  setDialog,
  resetForm,
  SettingsActions,
} from "../../../app/slices/settingsSlice";
import { Controller, useForm } from "react-hook-form";
import {
  HiOutlineCog6Tooth,
  HiOutlineAdjustmentsHorizontal,
} from "react-icons/hi2";
import FormDialog, { SectionCard, SwitchCard } from "../../../components/FormDialog";

const SettingsForm = () => {
  const dispatch = useDispatch();

  const _Setting = useSelector((state) => state.settings.setting);
  const _SearchBody = useSelector((state) => state.settings.searchBody);
  const loading = useSelector((state) => state.settings.settings.loading);

  const {
    formState: { errors },
    control,
    handleSubmit,
  } = useForm({
    defaultValues: _Setting.form,
  });

  const onSubmit = (data) => {
    dispatch(
      SettingsActions.update(
        data.id,
        {
          value: data.value,
          note: data.note,
        },
        _SearchBody
      )
    );
  };

  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const hasError = (fieldName) => {
    return !!errors[fieldName];
  };

  const handleDialog = () => {
    dispatch(setDialog());
  };
  return (
    <FormDialog
      open={_Setting.dialog}
      onClose={() => {
        handleDialog();
      }}
      icon={<HiOutlineCog6Tooth />}
      title={"تعديل"}
      subtitle="قم بتحديث قيمة الإعداد ثم احفظ التغييرات"
      onSubmit={handleSubmit(onSubmit)}
      saving={loading}
    >
      <SectionCard icon={<HiOutlineAdjustmentsHorizontal />} title="الإعداد">
        <Grid item xs={12}>
          <Controller
            name="value"
            control={control}
            rules={{
              required: { value: true, message: "الحقل مطلوب" },
              validate: (value) => {
                if (_Setting.form.key === "withdraw_by_rep_enabled") {
                  const numValue = Number(value);
                  if (numValue !== 0 && numValue !== 1) {
                    return "القيمة يجب أن تكون 0 أو 1 فقط";
                  }
                }
                return true;
              },
            }}
            render={({ field }) => {
              const switchKeys = [
                "withdraw_by_rep_enabled",
                "is_default_payment_fees",
                "active_e_payment",
              ];
              if (switchKeys.includes(_Setting.form.key)) {
                return (
                  <SwitchCard
                    field={{ ...field, value: Number(field.value) === 1 }}
                    onChange={(e) => field.onChange(e.target.checked ? 1 : 0)}
                    label={Number(field.value) === 1 ? "مفعل" : "غير مفعل"}
                  />
                );
              }
              return (
                <TextField
                  type="number"
                  size="small"
                  label="القيمة"
                  fullWidth
                  error={hasError("value")}
                  helperText={errors.value ? errors.value.message : ""}
                  inputProps={
                    _Setting.form.key === "withdraw_by_rep_enabled"
                      ? { min: 0, max: 1, step: 1 }
                      : {}
                  }
                  {...field}
                />
              );
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name="note"
            control={control}
            render={({ field }) => (
              <TextField
                size="small"
                label="الملاحظة"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default SettingsForm;
